import React from 'react';
import styled, {css} from 'styled-components';

const ImageComponent = styled.div`
  justify-self: end;
  height: ${props => props.theme.collecting.height};
  width: ${props => props.theme.collecting.height};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  border-top-right-radius: 10px;
  ${p => p.url && css`
    background-image: url('${p.url}');
  `}
  margin: ${props => props.theme.collecting.margin};
  border-radius: 30px;

  @media (min-width: 481px) {
    display: none;
  }

  @media (max-width: 480px) {
    height: ${props => props.theme.collecting.heightMobile};
    width: ${props => props.theme.collecting.heightMobile};
    margin: ${props => props.theme.collecting.marginMobile};
  }
`;

export default function CollectingImage({collectorInfo}) {
  if (!collectorInfo?.profileImagePublicUrl) {
    return null;
  }

  return <ImageComponent url={collectorInfo?.profileImagePublicUrl} />;
}
